import './popover.scss';
import { inject, bindable, customElement } from 'aurelia';
import { Popover as BootstrapPopover } from 'bootstrap';


@customElement('popover')
@inject(Element)
export class Popover {
    @bindable public idvalue: string;
    @bindable public header: string;
    @bindable public content: string;

    private readonly element: HTMLElement;

    constructor(element: any) {
        this.element = element as HTMLElement;
    }

    public iconClick(e: MouseEvent): void {
        e.preventDefault();
        const options = {
            placement: 'auto',
            title: this._title(),
            content: this.content,
            trigger: 'manual',
            animation: true,
            html: true,
            sanitize: false
        };
        const popoverElement = this.element.querySelector('[data-bs-toggle="popover"]');
        if (!popoverElement) {
            return;
        }

        const popover = BootstrapPopover.getInstance(popoverElement)
            ?? new BootstrapPopover(popoverElement, options as any);

        popover.toggle();
    }

    private _title(): string {
        return `<span class="text-info"><strong>${this.header}</strong></span`
        // <label style="position:absolute; top:0.2rem; right:1rem" class="close" click="alert('hello')">&times;</label>`;
    }


}
